/* SansMinds — storefront commerce behaviors (premium-theme parity layer).
   AJAX cart drawer + free shipping bar, quick-add, sticky add-to-cart,
   collection filters/sort, predictive search, product recommendations,
   announcement rotator. Vanilla JS, no dependencies. Idempotent. */
(function () {
  'use strict';

  var DRAWER_SECTION = 'cart-drawer';

  /* ----------------------------- helpers ------------------------------ */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lockScroll(on) { document.documentElement.classList.toggle('overlay-open', !!on); }

  function parseSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return selector ? doc.querySelector(selector) : doc.body;
  }

  /* --------------------- overlay focus management --------------------- */
  /* Save the trigger, move focus into the overlay, trap Tab within it, and
     restore focus on close — so keyboard/screen-reader users can't wander into
     the hidden page behind an open drawer/modal/lightbox (WCAG 2.4.3 / 2.1.2). */
  var _focusReturn = null;
  function focusables(container) {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(container.querySelectorAll(sel)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }
  function trapKeydown(e) {
    if (e.key !== 'Tab') return;
    var f = focusables(e.currentTarget);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openOverlay(el, focusTarget) {
    _focusReturn = document.activeElement;
    el.addEventListener('keydown', trapKeydown);
    var t = focusTarget || focusables(el)[0];
    if (t) setTimeout(function () { t.focus(); }, 30);
  }
  function closeOverlay(el) {
    el.removeEventListener('keydown', trapKeydown);
    if (_focusReturn && typeof _focusReturn.focus === 'function') { _focusReturn.focus(); }
    _focusReturn = null;
  }

  /* ----------------------------- cart drawer -------------------------- */
  function drawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lockScroll(true);
    openOverlay(d);
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    if (!d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.search-modal.is-open')) lockScroll(false);
    closeOverlay(d);
  }

  function renderDrawer(html) {
    var live = drawer(); if (!live || !html) return;
    var fresh = parseSection(html, '#cart-drawer');
    if (!fresh) return;
    live.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-cart-count');
    updateCount(count);
  }

  function updateCount(count) {
    var n = parseInt(count, 10); if (isNaN(n)) return;
    $all('[data-cart-count-bubble]').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('is-active', n > 0);
    });
  }

  function flashError(msg) {
    var panel = $('.cart-drawer__panel');
    if (!panel) { window.alert(msg); return; }
    var ex = panel.querySelector('[data-cart-error]');
    if (!ex) { ex = document.createElement('p'); ex.setAttribute('data-cart-error', ''); ex.className = 'cart-drawer__error u-small'; panel.insertBefore(ex, panel.children[1] || null); }
    ex.textContent = msg;
  }

  function addToCart(body, isForm) {
    var opts = { method: 'POST' };
    if (isForm) {
      body.append('sections', DRAWER_SECTION);
      opts.body = body;
      opts.headers = { 'Accept': 'application/json' };
    } else {
      body.sections = DRAWER_SECTION;
      opts.body = JSON.stringify(body);
      opts.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    }
    return fetch('/cart/add.js', opts).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { flashError(res.data && res.data.description || 'Could not add to cart.'); return; }
        if (res.data.sections && res.data.sections[DRAWER_SECTION]) renderDrawer(res.data.sections[DRAWER_SECTION]);
        openDrawer();
      })
      .catch(function () { flashError('Network error. Please try again.'); });
  }

  /* ----- add-to-cart flight -----------------------------------------------
     Clones the product image and arcs it to the bag so the add registers
     visually. The target is the app's fan trigger when present (the bag lives
     inside the fan), otherwise the header cart button. Silently does nothing
     if either end is missing, or if the visitor prefers reduced motion. */
  function cartTarget() {
    return document.querySelector('[data-pwa-fan-toggle]') || document.querySelector('[data-cart-toggle]');
  }

  function bumpTarget() {
    var t = cartTarget();
    if (!t) return;
    t.classList.remove('pwa-bump');
    // Reflow so the animation restarts on a repeat add.
    void t.offsetWidth;
    t.classList.add('pwa-bump');
    setTimeout(function () { t.classList.remove('pwa-bump'); }, 500);
  }

  function flyToCart(sourceImg) {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var target = cartTarget();
      if (!sourceImg || !target) return;
      var from = sourceImg.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width || !to.width) return;

      var fly = document.createElement('img');
      fly.src = sourceImg.currentSrc || sourceImg.src;
      fly.alt = '';
      fly.setAttribute('aria-hidden', 'true');
      fly.className = 'pwa-fly';
      var size = Math.min(from.width, 140);
      fly.style.left = from.left + 'px';
      fly.style.top = from.top + 'px';
      fly.style.width = size + 'px';
      fly.style.height = size + 'px';
      document.body.appendChild(fly);

      var dx = (to.left + to.width / 2) - (from.left + size / 2);
      var dy = (to.top + to.height / 2) - (from.top + size / 2);

      requestAnimationFrame(function () {
        fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
        fly.classList.add('pwa-fly--land');
      });
      setTimeout(function () {
        if (fly.parentNode) fly.parentNode.removeChild(fly);
        bumpTarget();
      }, 640);
    } catch (e) { /* decoration only — never block the add */ }
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: DRAWER_SECTION })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.sections && data.sections[DRAWER_SECTION]) renderDrawer(data.sections[DRAWER_SECTION]);
    });
  }

  /* ----- delegated cart events (survive drawer re-render) ----- */
  function bindCartDelegation() {
    if (document.documentElement.dataset.cartBound) return;
    document.documentElement.dataset.cartBound = '1';

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
      if (t.closest('[data-cart-close]')) {
        // Links (VIEW CART, item titles/images, continue shopping) close the
        // drawer AND navigate — don't preventDefault or navigation is swallowed.
        var closeLink = t.closest('a[href]');
        if (closeLink && !closeLink.hasAttribute('data-cart-toggle')) { closeDrawer(); return; }
        e.preventDefault(); closeDrawer(); return;
      }

      var qa = t.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        qa.classList.add('is-loading');
        addToCart({ id: qa.getAttribute('data-variant-id'), quantity: 1 }, false)
          .finally(function () { qa.classList.remove('is-loading'); });
        return;
      }

      var item = t.closest('[data-cart-item]');
      if (item) {
        var key = item.getAttribute('data-key');
        var input = item.querySelector('[data-line-qty]');
        if (t.closest('[data-line-remove]')) { e.preventDefault(); changeLine(key, 0); return; }
        if (t.closest('[data-line-minus]')) { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); return; }
        if (t.closest('[data-line-plus]')) { changeLine(key, parseInt(input.value, 10) + 1); return; }
      }
    });

    document.addEventListener('change', function (e) {
      var item = e.target.closest && e.target.closest('[data-cart-item]');
      if (item && e.target.matches('[data-line-qty]')) {
        changeLine(item.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); closeSearch(); }
    });

    /* Intercept product / featured-product add-to-cart forms */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"]');
        if (btn) btn.classList.add('is-loading');
        /* Grab the image BEFORE the request: the drawer re-render can replace
           the node we would otherwise measure. */
        var scope = form.closest('.product, .product__grid, .featured-product, main') || document;
        var srcImg = scope.querySelector('.product__media img, .product-card__img, .gallery__main img, img');
        addToCart(new FormData(form), true)
          .then(function () { flyToCart(srcImg); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      }
    });
  }

  /* --------------------------- sticky add-to-cart --------------------- */
  function initSticky() {
    var bar = $('[data-sticky-atc]'); var anchor = $('.product-form__cart');
    if (!bar || !anchor || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        bar.hidden = en.isIntersecting || !below;
        // Reserve space at the page bottom only while the fixed bar is visible,
        // so it never permanently covers the last bit of content.
        document.body.classList.toggle('sticky-atc-on', !bar.hidden);
      });
    }, { rootMargin: '0px 0px 0px 0px' }).observe(anchor);
  }

  /* --------------------------- collection facets ---------------------- */
  function initFacets(scope) {
    var form = $('[data-facets-form]', scope); if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var debounce;
    form.addEventListener('input', function (e) {
      if (e.target.type === 'number') { clearTimeout(debounce); debounce = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 600); }
    });
    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
    $all('[data-sort-select]').forEach(function (sel) {
      if (sel.dataset.ready) return; sel.dataset.ready = '1';
      sel.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });
    var toggle = $('[data-filter-toggle]', scope), facets = $('[data-facets]', scope);
    if (toggle && facets && !toggle.dataset.ready) {
      toggle.dataset.ready = '1';
      toggle.addEventListener('click', function () {
        var open = facets.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* --------------------------- predictive search ---------------------- */
  function searchModal() { return $('[data-search-modal]'); }
  function openSearch() {
    var m = searchModal(); if (!m) return;
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lockScroll(true);
    openOverlay(m, $('[data-search-input]', m));
  }
  function closeSearch() {
    var m = searchModal(); if (!m) return;
    if (!m.classList.contains('is-open')) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
    if (!$('.cart-drawer.is-open')) lockScroll(false);
    closeOverlay(m);
  }
  function initSearch() {
    if (document.documentElement.dataset.searchBound) return;
    document.documentElement.dataset.searchBound = '1';
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); openSearch(); }
      else if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    });
    var input = $('[data-search-input]'), results = $('[data-predictive-results]');
    if (!input || !results) return;
    var proxy = results.getAttribute('data-proxy') || '/apps/sansminds';
    var debounce, seq = 0;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { results.innerHTML = ''; return; }
      var mine = ++seq;
      debounce = setTimeout(function () {
        var url = proxy + '/search?q=' + encodeURIComponent(q) + '&predictive=1';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (mine !== seq) return; // a newer keystroke already fired
            data = data || {};
            data.groups = data.groups || {};
            // Archive + creators come from the theme-embedded metaobject JSON.
            var local = window.SMSearchLocal ? window.SMSearchLocal(q, 5) : { archive: [], creators: [] };
            data.groups.archive = local.archive;
            data.groups.creators = local.creators;
            results.innerHTML = renderPredictive(data, q);
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* Escape user/content text for safe innerHTML insertion. */
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---- client-side scoring for theme-embedded archive/creator metaobjects ----
     Mirrors the app's server scorer (whole-word-prefix, all-terms-must-match, NO
     typo tolerance). Exposed on window so the full search page reuses it. Reads
     the JSON emitted by snippets/search-modal.liquid ([data-sm-search-meta]). */
  (function () {
    function norm(s) {
      // NFKD + strip combining marks folds accents to ASCII (café → cafe); then
      // punctuation → space. The store's content is English, so ASCII is enough.
      return (s == null ? '' : String(s)).toLowerCase().normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s]/gi, ' ')
        .replace(/\s+/g, ' ').trim();
    }
    function tokenize(q) {
      return norm(q).split(' ').filter(function (t) { return t.length >= 2; }).slice(0, 8);
    }
    var cache = null;
    function entries() {
      if (cache) return cache;
      var el = document.querySelector('[data-sm-search-meta]');
      var data = { archive: [], creators: [] };
      if (el) { try { data = JSON.parse(el.textContent) || data; } catch (e) {} }
      cache = {
        archive: (data.archive || []).map(function (a) {
          return {
            type: 'archive', title: a.t, subtitle: a.c || 'Archive', url: a.u,
            fields: [
              { text: norm(a.t), weight: 10 },
              { text: norm(a.c), weight: 8 },
              { text: norm(a.s), weight: 3 },
            ],
          };
        }),
        creators: (data.creators || []).map(function (c) {
          return { type: 'creator', title: c.t, subtitle: 'Creator', url: c.u, fields: [{ text: norm(c.t), weight: 10 }] };
        }),
      };
      return cache;
    }
    function rank(list, tokens, perGroup) {
      var res = tokens.map(function (t) {
        return { re: new RegExp('(^|\\s)' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')), sub: t };
      });
      return list.map(function (e) {
        var score = 0;
        for (var i = 0; i < res.length; i++) {
          var best = 0;
          for (var j = 0; j < e.fields.length; j++) {
            var f = e.fields[j];
            if (res[i].re.test(f.text)) { if (f.weight > best) best = f.weight; }
            else if (f.text.indexOf(res[i].sub) >= 0) { var w = f.weight * 0.4; if (w > best) best = w; }
          }
          if (best === 0) return null;
          score += best;
        }
        return { e: e, score: score };
      }).filter(Boolean)
        .sort(function (a, b) { return b.score - a.score || a.e.title.localeCompare(b.e.title); })
        .slice(0, perGroup)
        .map(function (r) { return { type: r.e.type, title: r.e.title, subtitle: r.e.subtitle, url: r.e.url }; });
    }
    window.SMSearchLocal = function (q, perGroup) {
      var tokens = tokenize(q);
      if (!tokens.length) return { archive: [], creators: [] };
      var m = entries();
      return { archive: rank(m.archive, tokens, perGroup || 24), creators: rank(m.creators, tokens, perGroup || 24) };
    };
  })();

  /* Render the unified-search JSON payload into the predictive overlay. */
  function renderPredictive(data, q) {
    var g = (data && data.groups) || {};
    var html = '';
    if (g.products && g.products.length) {
      html += '<div class="ps__group"><p class="u-label u-muted ps__h">Products</p><ul class="ps__products" role="list">';
      g.products.forEach(function (p) {
        html += '<li><a class="ps__product" href="' + esc(p.url) + '">' +
          '<span class="ps__product-media">' +
          (p.image
            ? '<img class="ps__product-img" src="' + esc(p.image) + '" alt="" loading="lazy">'
            : '<span class="ps__product-img placeholder"></span>') +
          '</span><span class="ps__product-info">' +
          '<span class="ps__product-title">' + esc(p.title) + '</span>' +
          (p.price ? '<span class="ps__product-price u-mono u-small">' + esc(p.price) + '</span>' : '') +
          '</span></a></li>';
      });
      html += '</ul></div>';
    }
    [['archive', 'Archive'], ['creators', 'Creators'], ['editorial', 'Editorial'], ['articles', 'Journal']].forEach(function (pair) {
      var arr = g[pair[0]];
      if (!arr || !arr.length) return;
      html += '<div class="ps__group"><p class="u-label u-muted ps__h">' + pair[1] + '</p><ul role="list">';
      arr.forEach(function (it) {
        html += '<li><a class="ps__link" href="' + esc(it.url) + '">' + esc(it.title) +
          (it.subtitle ? ' <span class="u-muted u-small">— ' + esc(it.subtitle) + '</span>' : '') +
          '</a></li>';
      });
      html += '</ul></div>';
    });
    if (!html) return '<p class="ps__empty u-label u-muted">No results for “' + esc(q) + '”</p>';
    html += '<a class="ps__all btn-link" href="/search?q=' + encodeURIComponent(q) + '">View all results →</a>';
    return html;
  }

  /* --------------------------- recommendations ------------------------ */
  function initRecommendations(scope) {
    $all('[data-product-recommendations]', scope).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var url = el.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var inner = parseSection(html, '.recommendations');
        if (inner) el.innerHTML = inner.outerHTML;
      }).catch(function () {});
    });
  }

  /* --------------------------- announcement bar ----------------------- */
  function initAnnouncement(scope) {
    $all('[data-announcement]', scope).forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var items = $all('[data-announcement-item]', bar);
      if (items.length < 2) return;
      bar.setAttribute('data-js', '');
      var i = 0; items.forEach(function (it, n) { it.classList.toggle('is-active', n === 0); });
      var ms = parseInt(bar.getAttribute('data-announcement-rotate'), 10);
      if (!ms) { items[0].classList.add('is-active'); return; }
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* --------------------------- variant picker ------------------------- */
  function initVariantPicker(scope) {
    $all('[data-variant-picker]', scope).forEach(function (picker) {
      if (picker.dataset.ready) return; picker.dataset.ready = '1';
      var json = picker.querySelector('[data-variant-json]'); if (!json) return;
      var variants; try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var idInput = picker.querySelector('[data-variant-id]');
      var section = picker.closest('.shopify-section') || document;
      var inputs = $all('[data-option-input]', picker);

      function selected() {
        var arr = [];
        inputs.forEach(function (i) { if (i.checked) arr[parseInt(i.getAttribute('data-option-position'), 10) - 1] = i.value; });
        return arr;
      }
      function match() {
        if (!inputs.length) {
          var cur = idInput && idInput.value;
          return variants.filter(function (v) { return String(v.id) === String(cur); })[0] || variants[0];
        }
        var sel = selected();
        return variants.filter(function (v) {
          return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
        })[0];
      }
      function update() {
        $all('[data-option]', picker).forEach(function (fs) {
          var c = fs.querySelector('[data-option-input]:checked'), l = fs.querySelector('[data-option-selected]');
          if (c && l) l.textContent = c.value;
        });
        var v = match();
        var addButtons = $all('[data-add-button]', section);
        if (!v) {
          if (idInput) idInput.value = '';
          addButtons.forEach(function (b) { b.disabled = true; b.classList.remove('is-preorder'); var t = b.querySelector('[data-add-text]'); if (t) t.textContent = b.getAttribute('data-soldout'); });
          return;
        }
        if (idInput) idInput.value = v.id;
        $all('[data-price]', section).forEach(function (el) { el.textContent = v.price; });
        $all('.sticky-atc__price', section).forEach(function (el) { el.textContent = v.price; });
        $all('[data-compare]', section).forEach(function (el) {
          if (v.compare_at_price) { el.textContent = v.compare_at_price; el.hidden = false; } else { el.hidden = true; }
        });
        addButtons.forEach(function (b) {
          // Pre-order = purchasable but out of on-hand stock (continue-selling
          // made-to-order variant). Matches the backend overflow-waitlist rule.
          var preorder = v.available && v.inventory_management && v.inventory_quantity <= 0;
          b.disabled = !v.available;
          b.classList.toggle('is-preorder', !!preorder);
          var t = b.querySelector('[data-add-text]');
          if (t) {
            if (preorder) t.textContent = b.getAttribute('data-preorder') || b.getAttribute('data-add');
            else t.textContent = v.available ? b.getAttribute('data-add') : b.getAttribute('data-soldout');
          }
        });
        if (v.image) {
          $all('[data-gallery-main]', section).forEach(function (img) { img.src = v.image; img.srcset = ''; });
          $all('[data-gallery-thumb]', section).forEach(function (th) {
            if (th.getAttribute('data-full') === v.image) th.setAttribute('aria-current', 'true');
            else th.removeAttribute('aria-current');
          });
        }
        $all('[data-inventory]', section).forEach(function (el) {
          var thr = parseInt(el.getAttribute('data-threshold'), 10) || 0;
          if (v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= thr) {
            el.textContent = (el.getAttribute('data-label') || 'Only [c] left').replace('[c]', v.inventory_quantity);
            el.hidden = false;
          } else { el.hidden = true; }
        });
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
      }
      picker.addEventListener('change', function (e) { if (e.target.matches('[data-option-input]')) update(); });
      update();
    });
  }

  /* --------------------------- recently viewed ------------------------ */
  var RV_KEY = 'sm_recently_viewed';
  function recordRecentlyViewed() {
    var el = document.querySelector('[data-product-handle]'); if (!el) return;
    var handle = el.getAttribute('data-product-handle'); if (!handle) return;
    var list; try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function initRecentlyViewed(scope) {
    $all('[data-recently-viewed]', scope).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var current = el.getAttribute('data-exclude') || '';
      var list; try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
      list = list.filter(function (h) { return h && h !== current; });
      var max = parseInt(el.getAttribute('data-limit'), 10) || 4;
      list = list.slice(0, max);
      if (!list.length) return;
      var sectionId = el.getAttribute('data-section-id');
      Promise.all(list.map(function (h) {
        return fetch('/products/' + h + '?section_id=' + sectionId).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        var grid = el.querySelector('[data-recently-grid]'); if (!grid) return;
        htmls.forEach(function (html) {
          if (!html) return;
          var card = parseSection(html, '.product-card');
          if (card) { var li = document.createElement('li'); li.appendChild(card); grid.appendChild(li); }
        });
        if (grid.children.length) el.hidden = false;
      });
    });
  }

  /* --------------------------- image lightbox ------------------------- */
  function initLightbox() {
    if (document.documentElement.dataset.lbBound) return;
    document.documentElement.dataset.lbBound = '1';
    var box;
    function close() { if (box && box.classList.contains('is-open')) { box.classList.remove('is-open'); lockScroll(false); closeOverlay(box); } }
    document.addEventListener('click', function (e) {
      var main = e.target.closest('[data-gallery-main]');
      if (main && main.tagName === 'IMG') {
        if (!box) {
          box = document.createElement('div');
          box.className = 'lightbox'; box.setAttribute('data-lightbox', '');
          box.innerHTML = '<button type="button" class="lightbox__close" aria-label="Close">✕</button><img class="lightbox__img" alt="">';
          document.body.appendChild(box);
          box.addEventListener('click', function (ev) { if (ev.target === box || ev.target.closest('.lightbox__close')) close(); });
        }
        box.querySelector('.lightbox__img').src = main.src;
        box.classList.add('is-open'); lockScroll(true);
        openOverlay(box, box.querySelector('.lightbox__close'));
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* --------------------------- mega menu ------------------------------ */
  function initMegaMenu(scope) {
    $all('[data-has-mega]', scope).forEach(function (item) {
      if (item.dataset.ready) return; item.dataset.ready = '1';
      var btn = item.querySelector('[data-mega-trigger]');
      if (!btn) return;
      function open(o) { item.classList.toggle('is-open', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
      item.addEventListener('mouseenter', function () { open(true); });
      item.addEventListener('mouseleave', function () { open(false); });
      btn.addEventListener('click', function (e) { e.preventDefault(); open(!item.classList.contains('is-open')); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) open(false); });
    });
  }

  /* ----------------------- vertical video (reels) --------------------- */
  function initVideoTriggers() {
    if (document.documentElement.dataset.vidBound) return;
    document.documentElement.dataset.vidBound = '1';
    document.addEventListener('click', function (e) {
      // External embed: load the iframe on first click
      var trig = e.target.closest('[data-video-trigger]');
      if (trig) {
        e.preventDefault();
        var src = trig.getAttribute('data-embed'); if (!src) return;
        var em = trig.closest('.vvideo__media') || trig.parentNode;
        var frame = document.createElement('div');
        frame.className = 'vvideo__frame';
        var iframe = document.createElement('iframe');
        iframe.src = src; iframe.title = 'Video'; iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture'; iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        em.innerHTML = '';
        em.appendChild(frame);
        return;
      }
      // Inline video: play / pause toggle
      var tog = e.target.closest('[data-video-toggle]');
      if (tog) {
        e.preventDefault();
        var media = tog.closest('.vvideo__media');
        var vid = media && media.querySelector('video');
        if (!vid) return;
        if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        else { vid.pause(); }
        return;
      }
      // Inline video: mute / unmute (autoplay starts muted per browser policy)
      var snd = e.target.closest('[data-video-mute]');
      if (snd) {
        e.preventDefault();
        var sMedia = snd.closest('.vvideo__media');
        var sVid = sMedia && sMedia.querySelector('video');
        if (!sVid) return;
        sVid.muted = !sVid.muted;
        // Unmuting a paused clip should also start it playing.
        if (!sVid.muted && sVid.paused) { var sp = sVid.play(); if (sp && sp.catch) sp.catch(function () {}); }
      }
    });
  }

  function initVideoToggles(scope) {
    $all('.vvideo__media video', scope).forEach(function (vid) {
      if (vid.dataset.toggleReady) return; vid.dataset.toggleReady = '1';
      var media = vid.closest('.vvideo__media');
      function sync() { if (media) media.classList.toggle('is-playing', !vid.paused && !vid.ended); }
      function syncMute() {
        if (media) media.classList.toggle('is-muted', vid.muted);
        var btn = media && media.querySelector('[data-video-mute]');
        if (btn) btn.setAttribute('aria-pressed', vid.muted ? 'true' : 'false');
      }
      vid.addEventListener('play', sync);
      vid.addEventListener('pause', sync);
      vid.addEventListener('ended', sync);
      vid.addEventListener('volumechange', syncMute);
      sync();
      syncMute();
    });
  }

  /* ------------------------------ slideshow --------------------------- */
  function initSlideshow(scope) {
    $all('[data-slideshow]', scope).forEach(function (s) {
      if (s.dataset.ready) return; s.dataset.ready = '1';
      var slides = $all('[data-slide]', s);
      if (!slides.length) return;
      var dots = $all('[data-slide-dot]', s);
      var i = 0, timer;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { var ms = parseInt(s.getAttribute('data-autoplay'), 10); stop(); if (ms && slides.length > 1) timer = setInterval(function () { go(i + 1); }, ms); }
      var prev = s.querySelector('[data-slide-prev]'), next = s.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { go(i + 1); start(); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
      s.addEventListener('mouseenter', stop);
      s.addEventListener('mouseleave', start);
      go(0); start();
    });
  }

  /* --------------------- Localization pickers ------------------------- */
  /* Native <select> inside Shopify's localization form — currency and
     language both. Submitting the form switches the shopper's country or
     locale. We auto-submit on change so the visible "Update" button is only
     needed as a no-JS fallback. */
  function initCurrencyPicker(scope) {
    $all('[data-currency-picker] [data-currency-select], [data-language-picker] [data-language-select]', scope).forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }

  /* ------------------------------- init ------------------------------- */
  function initAll(scope) {
    initCurrencyPicker(scope || document);
    bindCartDelegation();
    initSearch();
    initSticky();
    initFacets(scope || document);
    initRecommendations(scope || document);
    initAnnouncement(scope || document);
    initVariantPicker(scope || document);
    initSlideshow(scope || document);
    initVideoTriggers();
    initVideoToggles(scope || document);
    initMegaMenu(scope || document);
    initRecentlyViewed(scope || document);
    initLightbox();
    recordRecentlyViewed();
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
